import { Grid, Typography } from "@material-ui/core";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import backgroundProvider from "../../../../../assets/img/backgroundProvider.png";
import DatePicker from "../../../../../components/common/DatePicker";
import ShowImage from "../../../../../components/common/ShowImage";
import TextFieldOutlined from "../../../../../components/common/TextFieldOutlined";
import UserContext from "../../../../../context/user-context";
import useShowImage from "../../../../../hooks/useShowImage";
import useStateDate from "../../../../../hooks/useStateDate";
import { useTranslation } from "../../../../../hooks/useTranslation";
import useUploadImage from "../../../../../hooks/useUploadImage";
import { setUserChange } from "../../../../../store/actions/userAction";
import { fileNames } from "../../../../../utils/imageUtil";
import { EntrantTabIndex } from "../../../../../utils/tabIndex";
import { VehicleData } from "../../Vehicle";

type validation = {
  register: any;
  errors: string;
};

type InsuranceSection = {
  form: validation;
};

type InsuranceSectionProps = {
  modified?: (data: VehicleData) => void;
  data: VehicleData;
};

const InsuranceSection = ({ modified, data }: InsuranceSectionProps) => {
  const { dispatch } = useContext(UserContext);
  const getImage = useShowImage();
  const [insuranceData, setInsuranceData] = useState(data);
  const { uploadNewPhoto } = useUploadImage();
  const { t, BundleKey } = useTranslation();
  const [insurancePhoto, setInsurancePhoto] = useState<any>(
    data.insurancePhotoNew || null
  );
  const [noActionMount, setNoActionMount] = useState(false);
  const { date, setDate } = useStateDate(insuranceData.insuranceExpirationDate);

  const handleInputChange = (value: string, name: string) => {
    setInsuranceData({ ...insuranceData, [name]: value });
  };

  const handleDatePickerChange = (
    name: string,
    date: MaterialUiPickersDate,
    fieldCheck: string,
    onSuccess?: () => void
  ) => {
    const dateParse = moment(date).format("DD-MM-YYYY");
    if (dateParse !== "Invalid date") {
      setInsuranceData({
        ...insuranceData,
        [name]: dateParse,
      });
      if (onSuccess) onSuccess();
    }
    dispatch(setUserChange(fieldCheck, date?.toString() === "Invalid Date"));
  };

  const uploadNewVehicleInsurancePhoto = (newPhoto: any) => {
    setInsurancePhoto(newPhoto);
    uploadNewPhoto(
      newPhoto,
      "insurancePhoto",
      fileNames.INSURANCE_FILENAME,
      false
    );
  };

  useEffect(() => {
    if (modified && noActionMount) modified(insuranceData);
    else setNoActionMount(true);
  }, [insuranceData]);

  useEffect(() => {
    if (noActionMount)
      setInsuranceData({
        ...insuranceData,
        insurancePhotoNew: insurancePhoto,
      });
  }, [insurancePhoto]);

  return (
    <Grid container spacing={3} style={{ paddingInline: 8 }}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          {t(BundleKey.DETAIL_ENTRYMETHOD_CAR_INSURANCE_TITLE)}
        </Typography>
      </Grid>

      <Grid item xs={12} md={6}>
        <DatePicker
          name="insuranceExpirationDate"
          id="insuranceExpirationDate"
          label={t(BundleKey.DETAIL_ENTRYMETHOD_CAR_INSURANCE_DATE)}
          size="medium"
          value={date}
          minDate={moment().add(1, "day").toDate()}
          minDateMessage={t(
            BundleKey.DETAIL_ENTRYMETHOD_CAR_INSURANCE_DATE_ERROR
          )}
          onchange={(date) => {
            setDate(date);
            handleDatePickerChange(
              "insuranceExpirationDate",
              date,
              "isInvalidInsuranceExpirationDate",
                () => {
                    if (modified) modified(insuranceData);
              }
            );
          }}
          tabIndex={EntrantTabIndex.dateInsurance}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextFieldOutlined
          required
          value={insuranceData.plate}
          autoFocus
          InputProps={{ tabIndex: EntrantTabIndex.plate }}
          name="plate"
          type="text"
          label={t(BundleKey.DETAIL_ENTRYMETHOD_CAR_INSURANCE_PLATE)}
          onChange={(value) => handleInputChange(value, "plate")}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextFieldOutlined
          value={insuranceData.brand}
          name="brand"
          type="text"
          label={t(BundleKey.DETAIL_ENTRYMETHOD_CAR_INSURANCE_BRAND)}
          onChange={(value) => handleInputChange(value, "brand")}
          InputProps={{ tabIndex: EntrantTabIndex.brand }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextFieldOutlined
          value={insuranceData.model}
          name="model"
          type="text"
          label={t(BundleKey.DETAIL_ENTRYMETHOD_CAR_INSURANCE_MODEL)}
          onChange={(value) => handleInputChange(value, "model")}
          InputProps={{ tabIndex: EntrantTabIndex.model }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextFieldOutlined
          value={insuranceData.color}
          name="color"
          type="text"
          label={t(BundleKey.DETAIL_ENTRYMETHOD_CAR_INSURANCE_COLOR)}
          onChange={(value) => handleInputChange(value, "color")}
          InputProps={{ tabIndex: EntrantTabIndex.color }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <ShowImage
          title={t(BundleKey.DETAIL_ENTRYMETHOD_CAR_INSURANCE_PHOTO)}
          defaultImage={backgroundProvider}
          image={insurancePhoto || getImage(data.insurancePhoto)}
          tabIndex={EntrantTabIndex.hidden}
          uploadNewPhoto={uploadNewVehicleInsurancePhoto}
          alt="vehicleInsurancePhoto"
          circle={false}
          small
        />
      </Grid>
    </Grid>
  );
};

export default InsuranceSection;
